/** @format */

import { useCallback, useRef } from 'react';
import { useBookingStore } from '@/ducks/bookingNew/hooks/useBookingStore';

type LoadingComponents =
  | 'availability'
  | 'bookingCommercialConditions'
  | 'bookingContractualConditions'
  | 'lightIdentity'
  | 'bookingOptions'
  | 'bookingRoom'
  | 'bookingCreate'
  | 'bookingValidateRoom'
  | 'bookingValidationUnified'
  | string;

export function useLoader(customId?: LoadingComponents) {
  const loaderId = useRef(customId ?? Math.floor(Math.random() * 1_000_000).toString()).current;

  const { loaders, addLoader: addLoaderStore, removeLoader: removeLoaderStore } = useBookingStore();
  const addLoader = useCallback(() => addLoaderStore(loaderId), [addLoaderStore, loaderId]);
  const removeLoader = useCallback(() => removeLoaderStore(loaderId), [removeLoaderStore, loaderId]);

  return { loading: loaders.includes(loaderId), addLoader, removeLoader };
}
